<script>
export default {
    data() {
        return {
            footerLeft: false,
            footerRight: false,
        }
    },
    computed: {
        fixed() {
            return this.footerLeft || this.footerRight
        },
    },
    methods: {
        setPortalLeft(val) {
            this.footerLeft = val
        },
        setPortalRight(val) {
            this.footerRight = val
        },
    },
}
</script>

<template lang="pug">
    //- no footer row at all while no page puts anything into it
    v-footer.footer-bar(:class="{ 'footer-bar--empty': !fixed }" :fixed="fixed" :absolute="!fixed" :height="fixed ? 75 : 0" app inset outlined)
        v-container.dd-page.py-2.py-md-3.d-flex(fluid)
            portal-target(name='footer' @change="setPortalLeft" multiple)
            v-spacer
            portal-target(name='footer-right' @change="setPortalRight")
</template>

<style scoped lang="scss">
// the page column (.dd-page) sets the sides, so the Save button lines up with the content
.footer-bar.v-footer {
    padding-right: 0;
    padding-left: 0;
}

.footer-bar--empty {
    overflow: hidden;
    padding: 0;
    border: 0 !important;
}

.footer-bar {
    background-color: #fff;

    &.v-sheet--outlined {
        border-width: 1px 0 0;
        border-style: solid;
        // the DoorDash merchant portal divider colour, same as the sidebar edge
        border-color: #e7e7e7;
    }
}
</style>
